export const SET_VAR = "SET_SESSION_VAR";
export const CLEAR = "CLEAR_SESSION";

export function set(name, value) {
	return {
		type: SET_VAR,
		data: {name,value}
	};
}

export function clear() {
	return {
		type: CLEAR
	}
}